import { autocompletion } from "@codemirror/autocomplete"
import { EditorView } from "@codemirror/view"
import CodeMirror, { ReactCodeMirrorRef } from "@uiw/react-codemirror"
import LabeledTheme from "app/codemirror/customizations/textFieldTheme"
import { liquid } from "app/codemirror/lezer-liquid/liquidLanguage"
import { AutocompleteFunction } from "app/codemirror/types"
import usePrevious from "app/core/hooks/usePrevious"
import { FocusEventHandler, forwardRef } from "react"
import { FieldInputProps } from "react-final-form"

const TextCodeFieldInput = forwardRef<
  ReactCodeMirrorRef,
  {
    autoCompeteFunction: AutocompleteFunction
    input: FieldInputProps<any, HTMLElement>
    prefix?: string
    onFocus?: () => void
    onBlur?: FocusEventHandler<HTMLInputElement>
  }
>(({ input, autoCompeteFunction, prefix, onFocus, onBlur, ...rest }, ref) => {
  const previousPrefix = usePrevious(prefix)

  const debounce = async () => {
    return new Promise((resolve) => {
      setTimeout(resolve, 100)
    })
  }

  const onChange = async (e: string) => {
    if (!!prefix && prefix !== previousPrefix) {
      await debounce()
      return
    }
    input.onChange(e)
  }

  return (
    <CodeMirror
      {...rest}
      minHeight="80px"
      value={input.value}
      onChange={async (e) => {
        await onChange(e)
      }}
      onFocus={onFocus}
      //@ts-ignore
      onBlur={onBlur}
      theme={LabeledTheme}
      extensions={[
        liquid,
        EditorView.lineWrapping,
        autocompletion({ override: [autoCompeteFunction] }),
      ]}
      ref={ref}
    />
  )
})

TextCodeFieldInput.displayName = "TextCodeFieldInput"

export default TextCodeFieldInput
